
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Performance KPI Framework. Per the Digital Data Room spec: operational
// KPIs, financial KPIs, assortment KPIs, compliance requirements. v0.5
// renders these via RichText + ContentCard widgets attached in JSON.
export function KPIFramework(props: PageTemplateProps) {
    return <BasePage {...props} />;
}
